/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

export const DefaultTransition = {
  functional: true,
  render(h, { children }) {
    const data = {
      attrs: { tag: 'div', name: 'toast', type: 'transition' },
    };
    return h('transition-group', data, children);
  },
};
